class BlueLabel extends Label {
    currentValue: string;

    constructor(oldContainer, controller, mode: string) {
        super(oldContainer.attr("id"), controller, oldContainer, mode);

        this.currentValue = null;
    }

    initHTML(oldElement) {
        this.currentValue = oldElement.html();
        this.container = oldElement;

        oldElement.attr("id", this.identifier + '_blue');
    }

   /* previewEnabled(enabled) {
        if (enabled && this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_enabled");
        } else if (!enabled && !this.container.hasClass("disabled")) {
            this.container.addClass("feedforward_disabled");
        }
    } */

    setValue(value) {
        this.currentValue = value;
        this.container.html(value);
    }

    getValue() {
        return this.currentValue;
    }

    previewValue(value: string, timeRatioLeft: number) {
        this.container.html(value);
        this.container.addClass("feedforward");
    }

    removePreviewValue() {
        this.container.html(this.currentValue);
        this.container.removeClass("feedforward");
    }
}